import CryptoJS from 'crypto-js';
export const encryptString = (data) => {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), 'fcrf#@key@123').toString();
     return ciphertext;
 };